// extracted by mini-css-extract-plugin
module.exports = {"service":"ServiceFormModal_service__12x1F"};